import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import { injectReducer } from "store/reducers";

export default store => ({
  path: "grading-periods-v2",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(/* webpackChunkName: "admin-academicSetup" */ "./components"),
      import(
        /* webpackChunkName: "admin-academicSetup" */ "AdminSettings/routes/GradingPeriodWrapper/modules/GradingPeriodsModule"
      ),
    ]).then(([importedModule0, importedModule1]) => {
      const component = importedModule0.default;
      const reducer = importedModule1.default;

      injectReducer(store, {
        key: "gradingPeriods",
        reducer,
      });

      return component;
    })
  ),
});
